
//73
Object.defineProperty(exports, "__esModule", { value: true });
require("./typography.st.css");
require("./colors.st.css");
module.exports.default = require("stylable/runtime").create(
    "root",
    "text1412147976",
    {"sizeMedium":"text1412147976--sizeMedium","sizeSmall":"text1412147976--sizeSmall","sizeTiny":"text1412147976--sizeTiny","weightThin":"text1412147976--weightThin","weightNormal":"text1412147976--weightNormal","weightBold":"text1412147976--weightBold","light":"text1412147976--light","root":"text1412147976--root"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/themes/backoffice/text.st.css
// module id = 309
// module chunks = 0